"use client";

import type { AsChildProps } from "@/types";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { Slot } from "./Slot";
export function AutoAnimate({ children, asChild }: AsChildProps<"div">) {
	const Component = asChild ? Slot : "div";
	const [parent] = useAutoAnimate();
	return <Component ref={parent}>{children}</Component>;
}
